import { NumberFormatterProps, NumberFormatter } from '@mantine/core';
import { ReactNode } from 'react';

type NumberProps = NumberFormatterProps & {
    unit?: string
    children: ReactNode
}

export const Number = ({ unit, children, ...props }: NumberProps) => {
    return (
        <NumberFormatter
            decimalSeparator=","
            suffix={` ${unit}`}
            thousandSeparator="&thinsp;"
            value={children?.toString()}
            {...props} />
    );
};